import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router } from '@angular/router';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { UserService, Driver } from './user.service';
import { Code, CommonService } from '../app.service';
import { MessageService } from '../common/message.service';
import { CompanyService, Company } from './company.service';
import { AppConstants, CODE, LOGON_INFO, DATEPICKER } from '../app.constants';
import $ from 'jquery';


@Component({
    selector: 'driver',
    templateUrl: 'driver.component.html',
    providers: [UserService, CompanyService]
})
export class DriverComponent implements OnInit, OnDestroy {

    CONST: any = AppConstants;

    driverList: Driver[];
    currentDriver: Driver;
    branchList: Company[] = [];
    licenseList: Code[];
    searchDriverList: Driver[];

    isLeaveDriverPage: boolean;

    pageTitle: string = "ドライバー";

    currPage: number;
    totalCount: number;
    PAGE_SIZE: number = AppConstants.PAGE_SIZE;

    search_comp_id: string = "";

    @ViewChild(NgForm) f: NgForm;

    myDatePickerOptions_noDisableUntil: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;

    today: Date;

    constructor(
        public userService: UserService,
        public companyService: CompanyService,
        public messageService: MessageService,
        private router: Router,
        public commonService: CommonService
    ) {  }

    ngOnInit() {
        this.licenseList = CODE.LICENSE_TYPE;

        this.today = new Date();

        this.currPage = 1;
        this.isLeaveDriverPage = this.router.url.indexOf('leave') > -1;

        this.branchList = this.companyService.getCompanyListForCombo();

        this.refreshPage();
    }


    driverUpdateModalShow(execDiv:string, driver:Driver){
        if (execDiv == this.CONST.REGIST) {
            this.clearSelectDriver();
            $('#driverUpdateModal .modal-title').text('【 '+this.pageTitle+'登録 】');
        } else {
            this.currentDriver = Object.assign({}, driver);
            $('#driverUpdateModal .modal-title').text('【 '+this.pageTitle+'修正 】');
        }

        $('#driverUpdateModal').modal('show');
    }


    //全営業所のドライバーリストを取得
    getDriverList() {
        this.userService.getDriverList(this.currPage, this.isLeaveDriverPage, true)
            .subscribe(
                data => {
                    this.driverList = [];
                    data['results'].forEach((d: any) => {
                        let c_nos: string[] = [];
                        if (d.car_nos) {
                            c_nos = d.car_nos.split(',');
                        }
                        this.driverList.push({
                            ...d,
                            license_expire_date: { jsdate: new Date(d.license_expire_date), formatted: d.license_expire_date},
                            car_no_1: c_nos.length >= 1 ? c_nos[0] : null,
                            car_no_2: c_nos.length >= 2 ? c_nos[1] : null,
                            car_no_3: c_nos.length >= 3 ? c_nos[2] : null
                        });
                    })
                    this.totalCount = data['count'];
                    this.getDriverSearchList();
                }
            );
    }

    //ドライバーリスト絞り込み
    getDriverSearchList() {
        if (this.search_comp_id) {
            this.searchDriverList = this.driverList.filter((e:Driver) => e.comp_id == this.search_comp_id);
        } else {
            this.searchDriverList = this.driverList;
        }

        this.totalCount = this.searchDriverList.length;
    }

    //ページ移動
    pageChange(page: number) {
        this.currPage = page;
        this.refreshPage();
    }


    //ドライバー登録
    registDriver() {
        if (this.f.invalid) {
            return;
        }
        this.userService.registDriver(this.currentDriver)
            .subscribe(
                data => {
                    //this.driverList.push(data);
                    this.messageService.addInfo(this.pageTitle + "【" + this.currentDriver.name + "】が新規登録されました。")
                    this.refreshPage();
                }
            );
    }

    //ドライバー更新
    updateDriver() {
        this.userService.updateDriver(this.currentDriver)
            .subscribe(
                data => {
                    this.messageService.addInfo("【" + this.currentDriver.name + "】の情報が更新されました。");
                    this.refreshPage();
                }
            );
    }

    //ドライバー削除
    deleteDriver() {
        this.userService.deleteDriver(this.currentDriver)
            .subscribe(
                data => {
                    //this.refreshPage();

                    this.driverList.splice(this.driverList.findIndex(({id}) => id == data.id), 1);
                    this.totalCount--;
                    this.clearSelectDriver();
                }
            );
    }

    //ドライバー復活
    reviveDriver() {
        this.userService.updateDriver(this.currentDriver)
            .subscribe(
                data => {
                    //this.refreshPage();

                    this.driverList.splice(this.driverList.findIndex(({id}) => id == data.id), 1);
                    this.totalCount--;
                    this.clearSelectDriver();
                }
            );
    }


    //画面リフレッシュ
    refreshPage(): void {
        this.clearSelectDriver();
        this.getDriverList();
    }

    //入力欄クリア
    clearSelectDriver(): void {
        this.currentDriver = new Driver();
        this.currentDriver.comp_id = "";
        this.currentDriver.license_type = "";
        this.f.resetForm(this.currentDriver);
        $('#driverUpdateModal').modal('hide');
    }


    exec() {
        switch ($('#confirmModal_btn').text()) {
            case "登録":
                this.registDriver();
                break;
            case "修正":
                this.updateDriver();
                break;
            case "削除":
                this.deleteDriver();
                break;
            case "復活":
                this.reviveDriver();
                break;
        }
    }


    setCustomError(control_name: string) {
        this.f.controls[control_name].setErrors({'custom':true});
        $('#'+control_name).addClass("is-invalid");
    }

    clearCustomError(control_name: string) {
        this.f.controls[control_name].setErrors(null);
        $('#'+control_name).removeClass("is-invalid");
    }


    ngOnDestroy() {
        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}



// WEBPACK FOOTER //
// ./src/app/member-kanri/driver.component.ts